// extracted by mini-css-extract-plugin
export default {"container":"container__pzKEA","image":"image__hiOSt"};